module.exports = __webpack_public_path__ + "a4bfb8bf36e03b057e67e396c92dbee1.fbx";